import { IconWrapper } from './IconWrapper'
import { IIconProps } from './props'

export function CarIcon(props: IIconProps) {
  return (
    <IconWrapper {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 9.07143H19M17.7143 14.0238V15.881C17.7143 16.0451 17.6466 16.2026 17.526 16.3187C17.4054 16.4348 17.2419 16.5 17.0714 16.5H15.1429C14.9724 16.5 14.8088 16.4348 14.6883 16.3187C14.5677 16.2026 14.5 16.0451 14.5 15.881V14.0238M17.7143 14.0238H2.28571M17.7143 14.0238V9.07143L15.3124 3.86756C15.2619 3.75815 15.1795 3.6652 15.0753 3.59996C14.971 3.53472 14.8493 3.5 14.725 3.5H5.275C5.15066 3.5 5.029 3.53472 4.92474 3.59996C4.82048 3.6652 4.7381 3.75815 4.68759 3.86756L2.28571 9.07143V14.0238M5.5 14.0238V15.881C5.5 16.0451 5.43227 16.2026 5.31171 16.3187C5.19115 16.4348 5.02764 16.5 4.85714 16.5H2.92857C2.75808 16.5 2.59456 16.4348 2.474 16.3187C2.35344 16.2026 2.28571 16.0451 2.28571 15.881V14.0238M4.85714 11.5476H6.14286M13.8571 11.5476H15.1429"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconWrapper>
  )
}
